import React from 'react';
import type { AreaId } from '../../../types/pulse';
import { ranking } from '../../../data/pulse';
import { RankCue } from '../RankCue';
interface RankScreenProps {
  value: (AreaId | null)[];
  onChange: (next: (AreaId | null)[]) => void;
}
export function RankScreen({
  value,
  onChange
}: RankScreenProps) {
  return <div className="flex flex-1 flex-col" data-id="element-270" data-mp="30l0vlbb3o68b">
      <h2 className="font-display text-[21px] font-semibold leading-[1.15] tracking-tight text-navy" data-id="element-271" data-mp="30k91k4x5igk5">
        {ranking.question}
      </h2>
      <p className="mt-2.5 text-[12px] leading-relaxed text-mut" data-id="element-272" data-mp="3acoj514jd34i">{ranking.instruction}</p>
      <p className="mt-1.5 flex items-center gap-1.5 text-[11px] leading-snug text-mut" data-id="element-273" data-mp="3oc6b1pd4owi3">
        <span className="h-2.5 w-2.5 shrink-0 rounded-sm border border-grass/50 bg-grass/20" aria-hidden="true" data-id="element-274" data-mp="3kacffvhsiios" />
        Green numbers are still free — used ones are locked.
      </p>

      <div className="mt-5" data-id="element-275" data-mp="1pwjxrepebn5p">
        <RankCue value={value} onChange={onChange} data-id="element-276" data-mp="1pxmjz9brx1fa" />
      </div>
    </div>;
}